var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-checkbox',_vm._b({attrs:{"id":_vm.id},on:{"input":function($event){return _vm.$emit('input', $event)}}},'el-checkbox',_vm.$attrs,false),[_vm._v("\n    "+_vm._s(_vm.label)+"\n  ")]),_vm._v(" "),(_vm.$slots.accessory)?_c('div',{staticClass:"el-form-item__accessory"},[_vm._t("accessory")],2):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }